import request from "src/utils/request";
import useApi from "src/scenes/integrations/notion-setup/use-api";
import getOverview from "src/scenes/dashboard/mock-data/overview";

const useJiraSetupApi = () => {
    const requestHandler = (abortController) => {
        return request(`/api/jira/setup`, { abortController });
    };

    return useApi(
        () => getOverview(),
        ({ abortController }) => requestHandler(abortController),
        undefined,
        `/api/jira/setup`
    );
};

export default useJiraSetupApi;
